/* utils/finishLogin.js */
import { getFirebaseAuth } from "@/lib/firebaseClient";
import { isLogoutInProgress } from "@/helpers/logoutClient";

export default async function finishLogin(api, router) {
  if (!api || typeof window === "undefined" || isLogoutInProgress()) {
    return false;
  }

  /* 0) Frisches ID-Token holen */
  let auth;
  try {
    auth = await getFirebaseAuth();
  } catch (err) {
    console.warn("[finishLogin] Firebase auth unavailable:", err?.message || err);
    return false;
  }

  const user = auth.currentUser;
  if (!user) {
    return false;
  }

  let idToken;
  try {
    idToken = await user.getIdToken(true);
  } catch (err) {
    console.warn("[finishLogin] Failed to get idToken:", err?.message || err);
    return false;
  }
  if (!idToken) {
    return false;
  }

  const res = await fetch(`${api}/login/session-cookie`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include", // schickt __session_api beim Refresh
    body: JSON.stringify({ idToken }),
  });

  if (!res.ok) {
    const backendError = await res.text().catch(() => "");
    const normalized = String(backendError || "").toLowerCase();
    if (!(res.status === 400 && normalized.includes("idtoken missing"))) {
      console.error("[finishLogin] backend error:", backendError);
    }
    return false;
  }

  const { sessionCookie } = await res.json().catch(() => ({}));
  if (!sessionCookie) {
    return false;
  }
  const sessionEmail = String(auth.currentUser?.email || "")
    .trim()
    .toLowerCase();

  const prod = process.env.NODE_ENV === "production";
  document.cookie = `__session_front=${sessionCookie}; Path=/; SameSite=Lax; Max-Age=${
    14 * 24 * 60 * 60
  }${prod ? "; Secure" : ""}`;
  if (sessionEmail) {
    document.cookie = `__session_front_email=${encodeURIComponent(
      sessionEmail,
    )}; Path=/; SameSite=Lax; Max-Age=${14 * 24 * 60 * 60}${
      prod ? "; Secure" : ""
    }`;
  }

  /* 3) Query-String (oobCode, email …) entfernen */
  const cleanUrl = window.location.pathname + window.location.hash;
  if (router) {
    router.replace(cleanUrl); // SPA-Navigation
  } else {
    window.history.replaceState({}, "", cleanUrl);
  }

  return true;
}
